export const categoryApiPath = '/categories';
export const jobApiPath = '/jobs';
export const translationsSuggestionsApiPath = '/translations/suggestions';
export const translationsSmartSuggestionsApiPath =
  '/translations/smart-suggestions';
